import { useDispatch, useSelector } from "react-redux";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import styles from "../SplitPayment/styles.module.scss";
import { PlusCircle } from "../../../../../assets/svgIcons";
import secondaryComponents from "../../..";
import { useState } from "react";
import { CreditDetails } from "./CreditDetailsForm";
import { updateCurrentPaymentInfo } from "../../../../../store/modules/checkoutInfo";
import primaryComponents from "../../../../primaryComponents";
import { setToDateMonthYearInWords } from "../../../../../helpers";

export const CreditPayment = () => {
  const { payment, customer } = useSelector((state) => state?.checkoutReducer);
  const [isActive, setIsActive] = useState(false);
  const dispatch = useDispatch();

  const updatePayment = (key, value) => {
    dispatch(
      updateCurrentPaymentInfo({
        key: "pay_with_credit",
        [key]: value,
      }),
    );
  };

  return (
    <>
      <section>
        <h5>Credit Payment</h5>

        <div className={`${globalStyles.cardWithBorder} `}>
          <div className="w-100 mb-2 d-flex justify-content-between align-items-center">
            <span
              className={`smallest-text-size gray--text ${styles.textBackground}`}
            >
              Credit Repayment Details
            </span>

            <primaryComponents.Button
              onClick={() => setIsActive(true)}
              classNames={"btn btn--outline"}
              style={{
                height: "40px",
                borderRadius: "20px",
                fontSize: "14px",
                padding: "0 15px",
              }}
            >
              <span className="mr-2">Add Details</span> <PlusCircle />
            </primaryComponents.Button>
          </div>
          <p>
            {payment?.pay_with_credit?.repayment_date || customer ? (
              <>
                <span className="dark--text font-weight-semibold mr-4">
                  {customer?.customerName || ""}
                </span>
                <span className="gray--text small-text-size">
                  {payment?.pay_with_credit?.repayment_date
                    ? setToDateMonthYearInWords(
                        payment?.pay_with_credit?.repayment_date,
                      )
                    : ""}
                </span>
              </>
            ) : (
              "No details available"
            )}
          </p>
        </div>
      </section>

      <secondaryComponents.Modal
        width={550}
        isActive={isActive}
        closeModal={() => setIsActive(false)}
      >
        <CreditDetails
          closeModal={() => setIsActive(false)}
          updatePayment={updatePayment}
        />
      </secondaryComponents.Modal>
    </>
  );
};
